module.exports = __webpack_public_path__ + "img/storm.afac4c31.png";